import React from 'react'
import PropTypes from 'prop-types'
import { isSSR } from './isSSR'

export default class SentryBoundary extends React.Component {
  static propTypes = {
    children: PropTypes.node,
  }

  componentDidCatch(error) {
    if (process.env.NODE_ENV === 'development') {
      console.error({
        error,
      })
    }
    if (typeof Sentry === 'undefined' && !isSSR) {
      document.dispatchEvent(new Event('loadTracking'))
      return window.sentryQueue.push({ error })
    }

    Sentry.captureException(error)
  }

  render() {
    return this.props.children
  }
}
